import { render } from "./MFApopup.vue?vue&type=template&id=956eca30&scoped=true"
import script from "./MFApopup.vue?vue&type=script&lang=js"
export * from "./MFApopup.vue?vue&type=script&lang=js"

import "./MFApopup.vue?vue&type=style&index=0&id=956eca30&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-956eca30"]])

export default __exports__